import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import extractErrorMessage from "util/extractErrorMessage";
import { searchEventsAlerts, bulkScheduleEventDefinitions } from "./api/eventsAPI";
export function useSearchEventsAlerts() {
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: searchEventsAlerts,
    onError: (error) => UserNotification.error(error.message)
  });
  return {
    searchEventsAlerts: mutateAsync,
    searchingEventsAlerts: isLoading
  };
}
export function useEnableEventDefinitions() {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: bulkScheduleEventDefinitions,
    onSuccess: async (_data, entityIds) => {
      UserNotification.success(`Enabled ${entityIds.length} event definition(s).`);
      await queryClient.invalidateQueries({ queryKey: ["get-threat-related-event-definitions"] });
      await queryClient.invalidateQueries({ queryKey: ["threat-coverage"] });
    },
    onError: (error) => UserNotification.error(`Failed to enable event definitions: ${extractErrorMessage(error)}`)
  });
  return {
    enableEventDefinitions: mutateAsync,
    enablingEventDefinitions: isPending
  };
}
